export enum InvariantTranslationKeys {
  // TODO: temporary, should eventually be retrieved from schema/GQL
  error = 'Error',
  correction = 'Correction'
}
